var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText05(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 52,
    viewBox: "0 0 44 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2996"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3065"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.9,
    d: "M21.0469 13.9531C21.0469 21.9375 24.5469 30.6328 33.2969 34.1875L29.0859 40.3672C23.2617 37.9609 19.4062 33.2578 17.1641 27.5156C14.9766 33.8047 11.0117 39 5.13281 41.625L0.648438 35.4453C9.34375 31.6172 13.0078 22.4297 13.0078 13.9531V11.9844H2.72656V5.58594H31.1094V11.9844H21.0469V13.9531ZM43.3047 0.828125V51.0312H35.375V0.828125H43.3047Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText05);
export default __webpack_public_path__ + "static/media/text05.b573ee4f672c9ccb5cf64e3d971426ba.svg";
export { ForwardRef as ReactComponent };